import React from 'react';
import styles from './ShareButton.scss';
import CSSModules from 'react-css-modules';
import { Experiment, Variation } from '@justgiving/experiments';
import { experiments } from 'src/constants/experiments';

export interface Props {
  handleShareClick: () => void;
}

const ShareButton: React.StatelessComponent<Props> = ({ handleShareClick }) => {
  const handleShareButtonClick = () => {
    handleShareClick();
  };

  return (
    // B2C_046 - Donate button prominence
    // Can be removed when experiment has ended
    <Experiment slug={experiments.b2c_046_donate_button_prominence}>
      <Variation name="A">
        <button
          type="button"
          className="jg-btn jg-btn--ghost"
          styleName="share-button"
          onClick={() => handleShareButtonClick()}
        >
          Share
        </button>
      </Variation>
      <Variation name="B">
        <button
          type="button"
          className="jg-btn"
          styleName="share-button plain"
          onClick={() => handleShareButtonClick()}
        >
          Share
        </button>
      </Variation>
    </Experiment>
  );
};

export default CSSModules(ShareButton, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/ShareModal/ShareButton.tsx